// Generate up to 3 opportunity insights from category scores.

const THRESHOLDS = {
  menu: 70,
  training: 65,
  service: 75,
  upsell: 70,
  updates: 65,
  feedback: 75,
};

const MESSAGES = {
  menu:
    "Staff may struggle with basic menu knowledge. Improving fluency could increase guest trust and upsell opportunities.",
  training:
    "Onboarding time may be long or inefficient. Faster, structured training could reduce ramp-up and improve consistency.",
  service:
    "Guest experience and consistency appear below target. Improving pre-shift briefs and storytelling can lift satisfaction.",
  upsell:
    "Upselling opportunities are being missed. Structured practice can lift beverage and add-on sales.",
  updates:
    "Menu updates and adoption speed may be lagging. Tightening update cadence and practice can lift alignment and sales.",
  feedback:
    "Feedback loops seem weak. Stronger QA and using guest feedback to guide changes can improve outcomes.",
};

/**
 * Generate up to 3 opportunity insights from category scores.
 * @param {Object} scores - { categories: { menu, training, service, upsell, engineering, feedback }, overall: number }
 * @returns {Array<{ category: string, message: string }>}
 */
export function generateInsights(scores) {
  const cats = scores?.categories || {};
  // Build list of categories with deficits
  const items = Object.keys(cats)
    .filter((k) => typeof cats[k] === "number")
    .map((k) => ({ key: k, score: cats[k], threshold: THRESHOLDS[k] ?? 0 }));

  const deficits = items
    .filter((it) => it.threshold > 0 && it.score < it.threshold)
    .sort((a, b) => a.score - b.score);

  return deficits.slice(0, 3).map((it) => ({
    category: it.key,
    message: MESSAGES[it.key] || "Area below target; focused improvements recommended.",
  }));
}
